





































export default {
    name: "SectionHeader",
    props: {
        icon: {
            type: String,
            default: ""
        },
        headerText: {
            type: String,
            default: ""
        }
    },
    data: () => ({}),
    methods: {}
};
